import Default from './default';

const Accordion = {
  Default,
};

export default Accordion;
